import { booleanAttribute, Component, input } from '@angular/core';
import { MatCard, MatCardContent } from '@angular/material/card';
import { CustomMatSvgIconDirective } from '@pct-ng/icon';
import { ProgressBarComponent } from '@pct-ng/common/component';
import { MatIcon } from '@angular/material/icon';
import type { Icons } from '@pct/icon';
import { fadeIn2XFastEnter, fadeInEnter } from '@pct-ng/animation';
import { MatRipple } from '@angular/material/core';
import {
  type FileUploadConfig,
  FormatFileSizePipe,
  IsMultipleFileUploadConfigPipe,
  JoinMimeTypeToExtensionPipe,
} from '@pct-ng/feature-file-upload-native';
import { IsNumberPipe } from '@pct-ng/common/pipe';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'pct-feature-file-upload-material-file-drop-zone-content',
  imports: [
    MatCard,
    MatCardContent,
    CustomMatSvgIconDirective,
    ProgressBarComponent,
    MatIcon,
    FormatFileSizePipe,
    MatRipple,
    IsMultipleFileUploadConfigPipe,
    IsNumberPipe,
    TranslocoDirective,
    JoinMimeTypeToExtensionPipe,
  ],
  templateUrl: './material-file-drop-zone-content.component.html',
  animations: [fadeInEnter, fadeIn2XFastEnter],
  host: {
    class: 'block !overflow-visible relative',
  },
})
export class MaterialFileDropZoneContentComponent {
  readonly i18nScope = input.required<string>();
  readonly hideCardShadow = input(false, { transform: booleanAttribute });
  readonly loading = input.required<boolean>();
  readonly uploading = input.required<boolean>();
  readonly config = input.required<FileUploadConfig>();
  readonly dragOver = input.required<boolean>();
  readonly centerIcon = input<Icons>('pct-mdi-cloud-upload-outline');
  readonly centerDragOverIcon = input<Icons>('pct-mdi-cloud-upload');
  readonly hasError = input<boolean>(false);
}
